import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { _isId } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceMovementService {

  constructor(private httpClientService: HttpClientService) { }

  async getByIdDeviceMovement(page, size, deviceId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeviceMovement,
      queryString: `Page=${page}&Size=${size}&deviceId=${deviceId}`,
      action: "GetAllMovementsByDeviceId"
    });
    return await firstValueFrom(observable);
  }

  async createDeviceMovement(deviceId: number, kindId: number, movementDate: Date, description?: string) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.DeviceMovement,
    },
      {
        deviceId: deviceId,
        appUserId: _isId,
        kindId: kindId,
        movementDate: movementDate,
        description: description
      });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}